module.exports = __webpack_public_path__ + "img/1557614075902500866.c779bbc7.png";